module.exports = __webpack_public_path__ + "7174452caff02905a384ae94f1b0da59.png";